export default __webpack_public_path__ + "static/media/addNFT.7f0802a6.png";